/*
	Generated on 07/05/2025 by UI Generator PRICES-IDE
	https://amanah.cs.ui.ac.id/research/ifml-regen
	version 3.9.0
*/
import React, { useEffect, useState, useContext} from 'react'
import { Button, Spinner, Modal } from "@/commons/components"
import * as Layouts from '@/commons/layouts';
import { Link } from "react-router";
import { useParams } from "@/commons/hooks/useParams"
import { HeaderContext } from "@/commons/components"
import { useNavigate } from "react-router";
import { useAuth } from '@/commons/auth';
import DetailMataKuliah from '../components/DetailMataKuliah'
import getMataKuliahDataDetail from '../services/getMataKuliahDataDetail'
import CPMKTable from "../components/CPMKTable";

import getCPMKDataList from '../services/getCPMKDataList'
import PrasyaratTable from "../components/PrasyaratTable";

import getPrasyaratMataKuliahDataList from '../services/getPrasyaratMataKuliahDataList'
import MataTable from "../components/MataTable";
import deleteAllMemberMataKuliah from '../services/deleteAllMemberMataKuliah';

import getGrupMataKuliahDataList from '../services/getGrupMataKuliahDataList'
const DetailMataKuliahPage = props => {
const { checkPermission } = useAuth();

	const [isLoading, setIsLoading] = useState({
	detailMataKuliah: false,
	daftarCPMK: false,
	daftarPrasyaratMataKuliah: false,
	daftarGroupMataKuliah: false,

	});
	const { setTitle } = useContext(HeaderContext);
	const { id }  = useParams()
	const navigate = useNavigate();

	const [showModalKonfirmasiHapusGrupMataKuliah, setShowModalKonfirmasiHapusGrupMataKuliah] = useState(false);
	const hapusGrup = async () => {
		const grupId = mataKuliahDataDetail?.grupMataKuliahId;
	  	  
		if (!grupId) {
		  return;
		}
	  
		try {
		  await deleteAllMemberMataKuliah({ id: grupId });
  		  window.location.reload()
		} catch (error) {
		}
	  };
	  
	  
const [mataKuliahDataDetail, setMataKuliahDataDetail] = useState()
useEffect(() => {
	const fetchData = async () => {
		try {
			setIsLoading(prev => ({...prev, detailMataKuliah: true}))
			const { data: mataKuliahDataDetail } = await getMataKuliahDataDetail({ id })
			setMataKuliahDataDetail(mataKuliahDataDetail.data)
		} finally {
			setIsLoading(prev => ({...prev, detailMataKuliah: false}))
		}
	}
	fetchData()
}, [])
const [cPMKDataList, setCPMKDataList] = useState()
	
	
	




	useEffect(() => {
		

		const fetchData = async () => {
			try {
				setIsLoading(prev => ({...prev, daftarCPMK: true}))
				const { data: cPMKDataList } = await getCPMKDataList({ mataKuliahId:id })
				setCPMKDataList(cPMKDataList.data)
			} finally {
				setIsLoading(prev => ({...prev, daftarCPMK: false}))
			}
		}
		fetchData()
  	}, [])
const [prasyaratMataKuliahDataList, setPrasyaratMataKuliahDataList] = useState()
	
	
	




	useEffect(() => {
		

		const fetchData = async () => {
			try {
				setIsLoading(prev => ({...prev, daftarPrasyaratMataKuliah: true}))
				const { data: prasyaratMataKuliahDataList } = await getPrasyaratMataKuliahDataList({ mataKuliahId:id })
				setPrasyaratMataKuliahDataList(prasyaratMataKuliahDataList.data)
			} finally {
				setIsLoading(prev => ({...prev, daftarPrasyaratMataKuliah: false}))
			}
		}
		if (checkPermission("ReadMataKuliahPrasyarat")) { 
			fetchData()
		}
  	}, [])
	  const [grupMataKuliahDataList, setGrupMataKuliahDataList] = useState();

	  useEffect(() => {
		const fetchData = async () => {
		  if (!mataKuliahDataDetail?.grupMataKuliahId) {
			return;
		  }
	  
		  try {
			setIsLoading(prev => ({ ...prev, daftarGroupMataKuliah: true }));
	  
			const { data: response } = await getGrupMataKuliahDataList({
			  grupMataKuliahId: mataKuliahDataDetail.grupMataKuliahId,
			});
	  
	  
			setGrupMataKuliahDataList(response.data);
		  } catch (error) {
		  } finally {
			setIsLoading(prev => ({ ...prev, daftarGroupMataKuliah: false }));
		  }
		};
	  
		fetchData();
	  }, [mataKuliahDataDetail]); 
	  
	  
	
	useEffect(() => {
		setTitle("Detail Mata Kuliah Page")
	}, []);
return (
	<Layouts.ViewContainerLayout
		buttons={
			<>
			<Layouts.ViewContainerBackButtonLayout>
			  	<Link to={`/matakuliah
			  	`}>
			  		<Button className="p-4 w-full" variant="secondary">
			  		  Kembali
			  		</Button>
			  	</Link>
			  	
			  	
			  </Layouts.ViewContainerBackButtonLayout>
			  	
			  <Layouts.ViewContainerButtonLayout>
			  	{checkPermission("SaveMataKuliahPrasyarat") &&  (
			  	  <Link to={`/matakuliah/${id}/prasyarat/tambah
			  	  `}>
			  	  	<Button className="p-2 w-full" variant="primary">
			  	  	  Tambah Prasyarat
			  	  	</Button>
			  	  </Link>
			  	  
			  	)}
			  	
			  	{checkPermission("SaveGrupMataKuliah") &&  (
			  	  <Link to={`/matakuliah/${id}/grup/tambah
			  	  `}>
			  	  	<Button id="_3wPocCT4EfC7sq91JcSRJg" className="p-2 w-full" variant="primary">
			  	  	  Tambah Grup
			  	  	</Button>
			  	  </Link>
			  	  
			  	)}
			  	
			  	{checkPermission("SaveGrupMataKuliah") &&  (
			  	  <Link to={`/matakuliah/${id}/grup/cari
			  	  `}>
			  	  	<Button id="_fnmGECT7EfC7sq91JcSRJg" className="p-2 w-full" variant="primary">
			  	  	  Cari Grup
			  	  	</Button>
			  	  </Link>
			  	  
			  	)} 	
			  	
			
			  </Layouts.ViewContainerButtonLayout>
			</>
		}
	>
		<Modal
		   isShow={showModalKonfirmasiHapusGrupMataKuliah}
		   title={"Konfirmasi Hapus Grup Mata Kuliah"}
		>
		   <Link to=''><Button variant="tertiary" onClick={() => setShowModalKonfirmasiHapusGrupMataKuliah(false)}>Batal</Button></Link>
		  <Button
			variant="danger"
			onClick={() => hapusGrup()}
		  >
			Hapus
		  </Button>
		</Modal>
<Layouts.DetailContainerLayout
	title={"Detail Mata Kuliah"}
	singularName={"Mata"}
	items={{...mataKuliahDataDetail}}
	isLoading={isLoading.detailMataKuliah}
	isCorrelatedWithAnotherComponent={false}
>
	<DetailMataKuliah {...{ data : { ...mataKuliahDataDetail }}} />
</Layouts.DetailContainerLayout>
<Layouts.ListContainerTableLayout
	title={"Daftar CPMK"}
	singularName={"CPMK"}
	items={[cPMKDataList]}
	isLoading={isLoading.daftarCPMK}
>
	<CPMKTable
		cPMKDataList={cPMKDataList}
		
	/>
</Layouts.ListContainerTableLayout>
{ checkPermission("ReadMataKuliahPrasyarat") && ( 
<Layouts.ListContainerTableLayout
	title={"Daftar Prasyarat Mata Kuliah"}
	singularName={"Prasyarat"}
	items={[prasyaratMataKuliahDataList]}
	isLoading={isLoading.daftarPrasyaratMataKuliah}
>
	<PrasyaratTable
		prasyaratMataKuliahDataList={prasyaratMataKuliahDataList}
		
	/>
</Layouts.ListContainerTableLayout>
)}
{ checkPermission("ReadGrupMataKuliah") && ( 
<Layouts.ListContainerTableLayout
	title={"Daftar Mata Kuliah Dalam Grup"}
	singularName={"Mata"}
	items={[grupMataKuliahDataList]}
	isLoading={isLoading.daftarMataKuliahDalamGrup}
>
	<MataTable
		grupMataKuliahDataList={grupMataKuliahDataList}
		
	/>
</Layouts.ListContainerTableLayout>
)}

{checkPermission("DeleteGrupMataKuliah") && (
  Array.isArray(grupMataKuliahDataList) &&
  grupMataKuliahDataList.length > 0 && (
    <div className="flex justify-end">
      <Button
        className="px-4 py-2 text-sm w-fit"
        variant="tertiary"
        onClick={() => setShowModalKonfirmasiHapusGrupMataKuliah(true)}
      >
        Hapus Grup Mata Kuliah
      </Button>
    </div>
  )
)}


	</Layouts.ViewContainerLayout>
  )
}
export default DetailMataKuliahPage

